/**
 * Centralized URL configuration for branding and external links.
 *
 * When whitelabeling or rebranding this app, update these values and redeploy.
 * All support, legal, and training links across the app pull from here.
 */

export const SUPPORT_URL = 'https://rockstarhelpdesk.com';
export const SUPPORT_TICKET_URL = 'https://rockstarhelpdesk.com/ticket/';
export const TERMS_URL = 'https://callsparker.com/terms';
export const PRIVACY_URL = 'https://callsparker.com/privacy';
export const TRAINING_URL = 'https://callsparker.com/training';
